import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {MessageService} from 'primeng/api';
import {catchError, throwError} from 'rxjs';
import {describeHttpError, SUPPRESS_ERROR_TOAST} from './shared/http-context';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((error: unknown) => {
      // The caller reports this one itself -- see silentErrors().
      if (req.context.get(SUPPRESS_ERROR_TOAST)) {
        return throwError(() => error);
      }

      const detail =
        error instanceof HttpErrorResponse
          ? `${error.status} ${error.statusText}: ${describeHttpError(error)}`
          : error instanceof Error
            ? error.message
            : 'An unexpected error occurred.';

      messageService.add({
        severity: 'error',
        summary: 'Request failed',
        detail,
        life: 8000,
      });

      return throwError(() => error);
    })
  );
};
